import axios from 'axios';
import qs from 'qs';

let turns = ['开始', '直行', '左转', '右转', '左前方', '右前方', '左后方', '右后方', '保持左侧', '保持右侧', '直行并靠左', '直行并靠右', '左转并靠左', '左转并靠右', '右转并靠左', '右转并靠右', '调头', '结束'];
let iconCls = ['r_s', 'r_st', 'r_l', 'r_r', 'r_lh', 'r_rh', 'r_lb', 'r_rb', 'r_kl', 'r_kr', 'r_stl', 'r_str', 'r_tll', 'r_tlr', 'r_trl', 'r_trr', 'r_tn', 'r_e'];
//let _commonAK = '1w117533x5P7N51a177p7BGmm99e5y53';
let _commonAK = "";
let lonlatPtn = /^([+-]?\d{1,3}(\.\d+)?,[+-]?\d{1,2}(\.\d+)?;?)+$/;
let plateNoPtn = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼][A-Z][A-Z0-9]{4}[A-Z0-9挂学警港澳]{1,2}$/;
//研究院坐标编码对照表
let lonlatCodeTable = {
    '0': 'a',
    '1': 'b',
    '2': 'e',
    '3': 'f',
    '4': 'n',
    '5': 'm',
    '6': 'k',
    '7': 'l',
    '8': 'g',
    '9': 'h',
    '.': ''
}

//设置超时时间为60s
axios.defaults.timeout = 30000;
//定义axios全局拦截器
axios.interceptors.request.use(config => {
    if(config.method != 'get'){ return config; }
    if(!config.params){ return config; }
	Object.keys(config.params).forEach(k => {
		if(typeof(config.params[k]) != 'string'){ return; }
		config.params[k] = config.params[k].replace(/\s+/g, '');
	});
	return config;
});

let cancels = [];
const CancelToken = axios.CancelToken;
// axios.interceptors.response.use(res => {
// 	let status = res.data && (res.data.code || res.data.status);
// 	if(res.status != 200 || (status && !([0, 200, 2001].includes(status)))){
//         let errinfo = { code: status || res.status, message: res.message || res.data.message || res.data.msg || '未知错误！' };
// 		return Promise.reject(errinfo, { duration: 6 });
// 	}
// 	return res.data;
// });



var hexcase = 0;  /* hex output format. 0 - lowercase; 1 - uppercase        */
var chrsz   = 8;  /* bits per input character. 8 - ASCII; 16 - Unicode      */

function hex_md5(s){ return binl2hex(core_md5(str2binl(s), s.length * chrsz));}
function hex_hmac_md5(key, data) { return binl2hex(core_hmac_md5(key, data)); }

/*
* Calculate the MD5 of an array of little-endian words, and a bit length
*/
function core_md5(x, len){
/* append padding */
x[len >> 5] |= 0x80 << ((len) % 32);
x[(((len + 64) >>> 9) << 4) + 14] = len;
var a =  1732584193;
var b = -271733879;
var c = -1732584194;
var d =  271733878;
for(var i = 0; i < x.length; i += 16)
{
var olda = a;
var oldb = b;
var oldc = c;
var oldd = d;
a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
a = safe_add(a, olda);
b = safe_add(b, oldb);
c = safe_add(c, oldc);
d = safe_add(d, oldd);
}
return Array(a, b, c, d);
}
/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5_cmn(q, a, b, x, s, t){
return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
}
function md5_ff(a, b, c, d, x, s, t){
return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t){
return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t){
return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t){
return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}
/*
* Calculate the HMAC-MD5, of a key and some data
*/
function core_hmac_md5(key, data)
{
var bkey = str2binl(key);
if(bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);
var ipad = Array(16), opad = Array(16);
for(var i = 0; i < 16; i++)
{
ipad[i] = bkey[i] ^ 0x36363636;
opad[i] = bkey[i] ^ 0x5C5C5C5C;
}
var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
return core_md5(opad.concat(hash), 512 + 128);
}
/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safe_add(x, y)
{
var lsw = (x & 0xFFFF) + (y & 0xFFFF);
var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
return (msw << 16) | (lsw & 0xFFFF);
}
/*
* Bitwise rotate a 32-bit number to the left.
*/
function bit_rol(num, cnt)
{
return (num << cnt) | (num >>> (32 - cnt));
}
/*
* Convert a string to an array of little-endian words
* If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
*/
function str2binl(str){
var bin = Array();
var mask = (1 << chrsz) - 1;
for(var i = 0; i < str.length * chrsz; i += chrsz)
bin[i>>5] |= (str.charCodeAt(i / chrsz) & mask) << (i%32);
return bin;
}
/*
* Convert an array of little-endian words to a hex string.
*/
function binl2hex(binarray){
var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
var str = "";
for(var i = 0; i < binarray.length * 4; i++)
{
str += hex_tab.charAt((binarray[i>>2] >> ((i%4)*8+4)) & 0xF) +
       hex_tab.charAt((binarray[i>>2] >> ((i%4)*8  )) & 0xF);
}
return str;
}


function ac(len) {
    len = (typeof (len) === 'number' && len > 5) ? len : 8;
    let str = [2, 3, 4, 5].map(v => Math.random().toString().slice(v, 8)).join('');
    return Number(str).toString(16).slice(0, len);
};


export default {
    commonAk: _commonAK,
    post (url, pms, appendAk) {
        if(appendAk){ url = `${url}?ak=${_commonAK}`; }
        return axios.post(url, pms, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            transformRequest: [function (data) { return qs.stringify(data); }]
        });
    },
    post2 (url, pms, config) {
        return axios.post(url, pms, config);
    },
    get (url, pms, appendAk) {
        if(appendAk){ pms = Object.assign(pms, { ak: _commonAK }); }
        cancels = [];
        return axios.get(url, { params: pms,cancelToken: new CancelToken(c => {
            cancels.push(c);
        }) });
    },
    get2 (url){
        cancels.forEach(cancel => cancel('中断请求'));
        cancels = [];
        return axios.get(url, {cancelToken: new CancelToken(c => {
            cancels.push(c);
        })});
    },
    reverseGeoNglp (lonlats, lang) {
        if(Array.isArray(lonlats)){ lonlats = lonlats.filter(v => lonlatPtn.test(v.toString())).join(';'); }
        if(lonlats.length == 0){ return; }
        //let pms = { lonlats: lonlats, poi: true, ak: _commonAK,road:true};
      
        if(['ch', 'en'].includes(lang)){ pms.language = lang; }
        cancels.forEach(cancel => cancel('中断请求'));
        cancels = [];
        let lbsnum = ac(8);
        let lbstm = parseInt(new Date().getTime()/1000);
        let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
        let md5str = hex_md5(str);
        let pms = { lonlats: lonlats, poi: true,road:true,lbssign:md5str,lbsnum:lbsnum,lbstm:lbstm};
        return axios.get('https://lbs.navinfo.com/develop-api/geocoder/v1/regeo', { params: pms,cancelToken: new CancelToken(c => {
            cancels.push(c);
        })});
    },
    reverseGeo(lonlats){
        if(!Array.isArray(lonlats)){ lonlats = [lonlats]; }
        lonlats = lonlats.filter(v => lonlatPtn.test(v.toString()));
        if(lonlats.length == 0){ return Promise.reject('没有合法的经纬度坐标串！'); }
        let tasks = [];
        lonlats.forEach(v => {
            v = v.split(/\,\s*/g);
            tasks.push(new Promise(function(resolve, reject){
                let pms = { inGb: 'g02', outGb: 'g02', zoom: 11, detail: 1, road: 1 };
                pms.lon = v[0];
                pms.lat = v[1];
                let lbsnum = ac(8);
                let lbstm = parseInt(new Date().getTime()/1000);
                let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
                let md5str = hex_md5(str);
                pms.lbssign = md5str;
                pms.lbsnum = lbsnum;
                pms.lbstm = lbstm;
                axios.get('/reverse/getInverseGeocoding.json', { params: pms}).then(res => resolve(res)).catch(err => reject(err));
            }));
        });
        return Promise.all(tasks);
    },
    getGeoInfo(keys){
        let tasks = [];
        if(!Array.isArray(keys)){ keys = [keys]; }
        keys.forEach(k => {
            tasks.push(new Promise(function(resolve, reject){
                let lbsnum = ac(8);
                let lbstm = parseInt(new Date().getTime()/1000);
                let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
                let md5str = hex_md5(str);
                let pms = { ak: _commonAK, addr: k,lbssign:md5str,lbsnum:lbsnum,lbstm:lbstm};
                axios.get('https://lbs.navinfo.com/develop-api/geocoder/v1/geo', { params: pms  }).then(data => resolve(data)).catch(err => reject(err));
            }));
        });
        return Promise.all(tasks);
    },
    getPoiList(keys, params){
        let tasks = [];
        if(!Array.isArray(keys)){ keys = [keys]; }
        cancels.forEach(cancel => cancel('中断请求'));
        cancels = [];
        keys.forEach(k => {
            tasks.push(new Promise(function(resolve, reject){
                let pms = { ak: _commonAK, kw: k, city: '110000', psize: 10, exinfo:2 };
                ['city', 'psize', 'language'].forEach(k => {
                    if(params && params[k]){ pms[k] = params[k]; }
                });
                let lbsnum = ac(8);
                let lbstm = parseInt(new Date().getTime()/1000);
                let str = 'lbsdevchecknum' + window.navigator.userAgent + lbstm;
                let md5str = hex_md5(str);
                pms.lbssign = md5str;
                pms.lbsnum = lbsnum;
                pms.lbstm = lbstm;
                axios.get('https://lbs.navinfo.com/develop-api/search/v1/text', {params: pms ,cancelToken: new CancelToken(c => {
                    cancels.push(c);
                })}).then(data => resolve(data)).catch(err =>   { if(err.message == '中断请求'){return};reject(err)});
            }));
        });
        return Promise.all(tasks);
    },
    getPoiSuggestList(keys, params){
        let tasks = [];
        if(!Array.isArray(keys)){ keys = [keys]; }
        cancels.forEach(cancel => cancel('中断请求'));
        cancels = [];
        keys.forEach(k => {
            tasks.push(new Promise(function(resolve, reject){
                let pms = { ak: _commonAK, kw: k, city: '110000'};
                ['city', 'psize', 'language'].forEach(k => {
                    if(params && params[k]){ pms[k] = params[k]; }
                });
                axios.get('https://lbs.navinfo.com/develop-api/suggest/v1/tips', {params: pms ,cancelToken: new CancelToken(c => {
                    cancels.push(c);
                })}).then(data => resolve(data)).catch(err =>   { if(err.message == '中断请求'){return};reject(err)});
            }));
        });
        return Promise.all(tasks);
    },
    formatCostTime (time, toSecond) {
        if(isNaN(time)){ return; }
        if(time < 60){ return `${time.toFixed(1)}秒`; }
        let h = Math.floor(time / 3600);
        let m = Math.floor((time % 3600) / 60);
        let s = Math.floor(time % 60);
        let str = toSecond ? `${s}秒` :  `${m}分钟`;
        if(m > 0 && toSecond){ str = `${m}分${str}`; }
        if(h > 0){ str = toSecond && (m == 0) ? `${h}小时零${str}` : `${h}小时${str}`; }
        return str;
    },
    formatDist (dist) {
        if(dist > 1000){ return `${(dist / 1000).toFixed(2)}公里`; }
        return `${dist}米`;
    },
    formatTime (time, format){
        time = typeof(time) === "number" ? time : time instanceof Date ? time.getTime() : (time | 0);
        if(time === 0){ return null; }
        format = typeof(format) === 'string' && (!!format) ? format.replace(/\b([mdhs])\1*\b/ig, '$1$1').replace(/\byy+\b/ig, 'yyyy') : 'yyyy-MM-dd hh:mm:ss';
        var _time = new Date(time);
        time = _time.toString().split(/[\s\:]/g).slice(0, -2);
        time[1] = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'][_time.getMonth()];
        var mapping = { MM: 1, dd: 2, yyyy: 3, hh: 4, mm: 5, ss: 6 };
        return format.replace(/([Mmdhs]|(?:yy))\1*/g, (key) => time[mapping[key]]);
    },
    turnType2Icon (turnType) {
        let idx = turns.indexOf(turnType);
        if(idx == -1){ return iconCls[1]; }
        return iconCls[idx];
    },
    encodeLonlat (lonlat, len) {
        len = len || 5;
        if(typeof(lonlat) === 'number'){ lonlat = lonlat.toString(); }
        if(typeof(lonlat) !== 'string'){ return lonlat; }
        //非坐标格式
        if(!lonlatPtn.test(lonlat)){ return lonlat; }
        let exp = new RegExp(`(\\.\\d{${len}})\\d*\\b`, 'g');
        lonlat = lonlat.replace(/(\.\d{1,4})\b/g, '$10000').replace(exp, '$1');
        return lonlat.replace(/[\d\.]/g, (c) => lonlatCodeTable[c]);
    },
    fixLonlat(lonlat, length){
        if(typeof(lonlat) !== 'string'){ return lonlat; }
        length = length || 5;
        let exp = new RegExp(`\(\\.\\d\{1,${length}\}\)\\d\*\\b`, 'g');
        return lonlat.replace(exp, '$1');
    },
    isLonlat (str) {
        if(!str){ return false; }
        str = str.toString();
        return lonlatPtn.test(str);
    },
    isPlateNo (str) {
        if(!str || typeof(str) !== 'string'){ return false; }
        return plateNoPtn.test(str);
    },
    isHostValid (str) {
        if(!str){ return false; }
        if(/^(https?\:\/{2})?localhost(\:\d{1,5})?\/?$/.test(str)){ return true; }
        if(/^(https?\:\/{2})?((1|2)?\d{1,2}\.){3}(1|2)?\d{1,2}(\:\d{1,5})?\/?$/.test(str)){ return true; }
        if(/^(https?\:\/{2})?[\w\-]+(\.[\w\-]+)?\.com\/?$/.test(str)){ return true; }
        return false;
    },
    isInPolygon(checkPoint, polygonPoints) {
        let counter = 0;
        let i;
        let xinters;
        let p1, p2;
        let pointCount = polygonPoints.length;
        p1 = polygonPoints[0];
        //从点出发一条射线与多边形相交，如果交点为奇数，就在多边形内，如果交点为偶数，就不在多边形。
        for (i = 1; i <= pointCount; i++) {
            p2 = polygonPoints[i % pointCount];
            if ( checkPoint[0] > Math.min(p1[0], p2[0]) && checkPoint[0] <= Math.max(p1[0], p2[0]) ) {
                if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
                    if (p1[0] != p2[0]) {
                        xinters =  (checkPoint[0] - p1[0]) * (p2[1] - p1[1]) / (p2[0] - p1[0]) + p1[1];
                        if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
                            counter++;
                        }
                    }
                }
            }
            p1 = p2;
        }
        if (counter % 2 == 0) {
            return false;
        } else {
            return true;
        }
    },
    ac(len){
        len = (typeof (len) === 'number' && len > 5) ? len : 8;
        let str = [2, 3, 4, 5].map(v => Math.random().toString().slice(v, 8)).join('');
        return Number(str).toString(16).slice(0, len);
    },
    hex_md5:hex_md5,
    rayCasting(p, poly) {
        var px = p[0],
            py = p[1],
            flag = false
    
        for(var i = 0, l = poly.length, j = l - 1; i < l; j = i, i++) {
          var sx = poly[i][0],
              sy = poly[i][1],
              tx = poly[j][0],
              ty = poly[j][1]
    
          // 点与多边形顶点重合
          if((sx === px && sy === py) || (tx === px && ty === py)) {
            return 'on'
          }
    
          // 判断线段两端点是否在射线两侧
          if((sy < py && ty >= py) || (sy >= py && ty < py)) {
            // 线段上与射线 Y 坐标相同的点的 X 坐标
            var x = sx + (py - sy) * (tx - sx) / (ty - sy)
    
            // 点在多边形的边上
            if(x === px) {
              return 'on'
            }
    
            // 射线穿过多边形的边界
            if(x > px) {
              flag = !flag
            }
          }
        }
        // 射线穿过多边形边界的次数为奇数时点在多边形内
        return flag ? 'in' : 'out'
      },
    debounce(fn, interval){
        let _self = fn, lastTime, timer;
        if(typeof(interval) !== 'number' || interval <= 0){
            interval = 500;
        }
        return function(){
            let ctx = this,
                args = Array.prototype.slice.call(arguments),
                now = new Date().getTime();
            if(lastTime && now - lastTime < interval){
                clearTimeout(timer);
            }
            lastTime = now;
            timer = setTimeout(() => {
                clearTimeout(timer);
                _self.apply(ctx, args);
            }, interval);
        }
    },
    deepClone1(target) {
        // 定义一个变量
        let result;
        // 如果当前需要深拷贝的是一个对象的话
        if (typeof target === 'object') {
        // 如果是一个数组的话
            if (Array.isArray(target)) {
                result = []; // 将result赋值为一个数组，并且执行遍历
                for (let i in target) {
                    // 递归克隆数组中的每一项
                    result.push(deepClone1(target[i]))
                }
            // 判断如果当前的值是null的话；直接赋值为null
            } else if(target===null) {
                result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值    
            } else if(target.constructor===RegExp){
                result = target;
            }else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
                result = {};
                for (let i in target) {
                    result[i] = deepClone1(target[i]);
                }
            }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
        } else {
            result = target;
        }
        // 返回最终结果
        return result;
    }
}
